import { saveAs } from "file-saver";
import ExcelJS from "exceljs";

export const getSheetData = (data, header) => {
  var fields = Object.keys(data[0]);
  var sheetData = data.map(function (row) {
    return fields.map(function (fieldName) {
      return row[fieldName] ? row[fieldName] : "";
    });
  });
  sheetData.unshift(header);
  return sheetData;
};

export const saveAsExcel = async (data, columns, fileName) => {
  const workbook = new ExcelJS.Workbook();
  const worksheet = workbook.addWorksheet("Sheet");

  // Extract headers from columns
  let filterColumns = columns?.filter((d) => d?.text !== "Action");

  const headers = filterColumns.map((col) => col.text);
  const fields = filterColumns.map((col) => col.dataField);
  // console.log("headerssssss", headers);
  // console.log("fieldsssss", fields);

  // Add header row
  worksheet.addRow(headers);

  // Style the headers
  const headerRow = worksheet.getRow(1);
  headerRow.eachCell((cell) => {
    cell.font = { bold: true };
    cell.alignment = { horizontal: "center" };
  });

  // Add rows dynamically based on columns and data
  Array.isArray(data) &&
    data
      .map((d, idx) => ({ ...d, sid: idx + 1 }))
      .forEach((row) => {
        const rowData = fields.map((field) => {
          // Handle nested fields like "users.firstName"
          const fieldParts = field.split(".");
          let value = row;
          fieldParts.forEach((part) => {
            value = value ? value[part] : "";
          });

          // Find formatter if any for this column
          // const column = filterColumns.find((col) => col.dataField === field);
          // if (column?.formatter) {
          //   return column.formatter(value, row);
          // }

          return value;
        });
        worksheet.addRow(rowData);
      });

  // Adjust column widths based on content
  worksheet.columns.forEach((column) => {
    let maxLength = 10; // Default width
    column.eachCell({ includeEmpty: true }, (cell) => {
      const length = (cell.value || "").toString().length;
      if (length > maxLength) {
        maxLength = length;
      }
    });
    column.width = maxLength + 2;
  });

  // Generate and download the Excel file
  const buffer = await workbook.xlsx.writeBuffer();
  const dataBlob = new Blob([buffer], { type: "application/octet-stream" });
  const excelFileName = fileName || "ReportExcel.xlsx";
  saveAs(dataBlob, excelFileName);
};
